// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.rc-tree .rc-tree-treenode span.rc-tree-switcher {
  background: transparent none repeat 0 0 / auto auto padding-box border-box scroll;
  background: initial;
}

.rc-tree .rc-tree-treenode span.rc-tree-iconEle {
  height: auto;
  height: initial;
  width: auto;
  width: initial;
  margin: 0;
  margin: initial;
  line-height: inherit;
}

.rc-tree .rc-tree-treenode .rc-tree-node-selected {
  background: transparent none repeat 0 0 / auto auto padding-box border-box scroll;
  background: initial;
  -webkit-box-shadow: none;
          box-shadow: none;
  -webkit-box-shadow: initial;
          box-shadow: initial;
  opacity: 1;
  opacity: initial;
  border: medium none currentcolor;
  border: initial;
}

.noHPad_xWDg8 {
  padding-left: 0;
  padding-right: 0;
}

.node_D7KB7.win_Dx4Pw {
  -webkit-box-align: center;
      -ms-flex-align: center;
          align-items: center;
}

.selectedNode_JCVdq {
  background-color: #b9e4e4;
  background-color: var( --color-Brand050, #b9e4e4 );
}

.rc-tree .rc-tree-treenode .rc-tree-node-content-wrapper {
  height: auto;
  height: initial;
  width: auto;
  width: initial;
  margin: 0;
  margin: initial;
  line-height: inherit;
}

.rc-tree .rc-tree-treenode {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
      -ms-flex-align: center;
          align-items: center;
  -webkit-box-pack: start;
      -ms-flex-pack: start;
          justify-content: flex-start;
}`, "",{"version":3,"sources":["webpack://./../../node_modules/@leverege/ui-elements/lib/esm/Tree.css"],"names":[],"mappings":"AAAA;EACE,iFAAiB;EAAjB,mBAAiB;AACnB;;AAEA;EACE,YAAa;EAAb,eAAa;EACb,WAAY;EAAZ,cAAY;EACZ,SAAa;EAAb,eAAa;EACb,oBAAkB;AACpB;;AAEA;EACE,iFAAiB;EAAjB,mBAAiB;EACjB,wBAAiB;UAAjB,gBAAiB;EAAjB,2BAAiB;UAAjB,mBAAiB;EACjB,UAAc;EAAd,gBAAc;EACd,gCAAa;EAAb,eAAa;AACf;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,yBAAmB;MAAnB,sBAAmB;UAAnB,mBAAmB;AACrB;;AAEA;EACE,yBAAkD;EAAlD,kDAAkD;AACpD;;AAEA;EACE,YAAa;EAAb,eAAa;EACb,WAAY;EAAZ,cAAY;EACZ,SAAa;EAAb,eAAa;EACb,oBAAkB;AACpB;;AAEA;EACE,oBAAa;EAAb,oBAAa;EAAb,aAAa;EACb,yBAAmB;MAAnB,sBAAmB;UAAnB,mBAAmB;EACnB,uBAA2B;MAA3B,oBAA2B;UAA3B,2BAA2B;AAC7B","sourcesContent":[":global( .rc-tree .rc-tree-treenode span.rc-tree-switcher ) {\n  background: unset;\n}\n\n:global( .rc-tree .rc-tree-treenode span.rc-tree-iconEle ) {\n  height: unset;\n  width: unset;\n  margin: unset;\n  line-height: unset;\n}\n\n:global( .rc-tree .rc-tree-treenode .rc-tree-node-selected ) {\n  background: unset;\n  box-shadow: unset;\n  opacity: unset;\n  border: unset;\n}\n\n.noHPad {\n  padding-left: 0;\n  padding-right: 0;\n}\n\n.node.win {\n  align-items: center;\n}\n\n.selectedNode {\n  background-color: var( --color-Brand050, #b9e4e4 );\n}\n\n:global( .rc-tree .rc-tree-treenode .rc-tree-node-content-wrapper ) {\n  height: unset;\n  width: unset;\n  margin: unset;\n  line-height: unset;\n}\n\n:global( .rc-tree .rc-tree-treenode ) {\n  display: flex;\n  align-items: center;\n  justify-content: flex-start;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"noHPad": `noHPad_xWDg8`,
	"node": `node_D7KB7`,
	"win": `win_Dx4Pw`,
	"selectedNode": `selectedNode_JCVdq`
};
export default ___CSS_LOADER_EXPORT___;
